import { KnowledgeDomainType } from "../../../types/KnowledgeDomain";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { del, get, post, put } from "../../../utils/axios-config";
import { KNOWLEDGE_DOMAINS } from "../../../utils/constants";

export const createKnowledgeDomain = async (data:KnowledgeDomainType) => 
    await post(KNOWLEDGE_DOMAINS, data);

export const getKnowledgeDomains = async (data:PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    return await get<PagedResultsType<KnowledgeDomainType>>(`${KNOWLEDGE_DOMAINS}?${queryParams.toString()}`);
};

export const updateKnowledgeDomain = async (data:KnowledgeDomainType) => 
    await put(KNOWLEDGE_DOMAINS, data);

export const deleteKnowledgeDomain = async (id:string) => 
    await del(`${KNOWLEDGE_DOMAINS}/${id}`,{});
